import axios from "axios";
import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { UserConsumer } from "../../../UserContext";
import { AlertPopups } from "../../../components/AlertPopups";
import { EmployeesMonthlyLeaves_API } from "./EmployeesMonthlyLeaves_API";
import Header from "../../../components/Header";
import FilterationBar from "./FilterationBar";
import moment from "moment";
import { Col, Row } from "reactstrap";
import EmployeesMonthlyLeavesTable from "./EmployeesMonthlyLeavesTable";
import ButtonLoader from "../../../components/ButtonLoader";
import {
	ExcelBtnClassName,
	ExcelBtnTitle,
} from "../../ticketModule/variables/ListingVariables";

function EmployeesMonthlyLeaves() {
	let token,
		empRole,
		designation,
		empDepartment = null;

	const defaultSorted = [
		{
			dataField: "token",
			order: "desc",
		},
	];
	const [startDate, setStartDate] = useState();
	const [endDate, setEndDate] = useState();
	const [employeeList, setEmployeeList] = useState(null);
	const [selectedEmployee, setSelectedEmployee] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const [apiHeaderToken, setApiHeaderToken] = useState(null);
	const [endDatePickerDisabled, setEndDatePickerDisabled] = useState(true);
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(10);
	const [employeeMonthlyLeavesData, setEmployeeMonthlyLeavesData] = useState(
		[]
	);
	const [showBtnLoading, setShowBtnLoading] = useState(false);
	const sortBy = useState(defaultSorted[0]);

	useEffect(() => {
		const tokenHeader = {
			Authorization: `Bearer ${token}`,
		};
		setApiHeaderToken(tokenHeader);
		let StartDateFormated = moment(new Date()).subtract(30, "days")._d;
		let endDateFormated = moment(new Date())._d;
		setStartDate(StartDateFormated);
		setEndDate(endDateFormated);

		if (
			empRole.includes("3") ||
			designation.toString() === "4" ||
			empDepartment === "5"
		)
			// Employee List for CM/Admin/finance:
			axios
				.get(`${EmployeesMonthlyLeaves_API.GetAllActiveEmployeeList}`, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then(({ data }) => {
					const supEmpList = data.map((obj) => {
						return { value: obj.employeeId, label: obj.name };
					});
					setEmployeeList(
						supEmpList.sort((a, b) =>
							a.label.localeCompare(b.label)
						)
					);
					supEmpList.unshift({ value: 0, label: "All" });
					setSelectedEmployee({ value: 0, label: "All" });
				});
		// Employee List for supervisors:
		else
			axios
				.get(
					`${EmployeesMonthlyLeaves_API.GetSupervisorsEmployeesList}`,
					{
						headers: tokenHeader,
					}
				)
				.then(({ status, data }) => {
					if (status === 200) {
						const supEmpList = data.map((obj) => {
							return { value: obj.employeeId, label: obj.name };
						});
						setEmployeeList(
							supEmpList.sort((a, b) =>
								a.label.localeCompare(b.label)
							)
						);
						supEmpList.unshift({ value: 0, label: "All" });
						setSelectedEmployee({ value: 0, label: "All" });
					}
				});

		axios
			.get(
				`${
					EmployeesMonthlyLeaves_API.GetEmployeesMonthlyLeaves
				}?EmployeeId=${0}&PageSize=${numberOfItemsPerPage}&StartDate=${moment(
					new Date()
				)
					.subtract(30, "days")
					.format("YYYY-MM-DD")}&EndDate=${moment(new Date()).format(
					"YYYY-MM-DD"
				)}&SortBy=${sortBy.dataField}_${sortBy.order}`,
				{
					headers: tokenHeader,
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setEmployeeMonthlyLeavesData(
						res.data.employeeMonthlyLeaves
					);
				}
			});
	}, []);

	const filterOnEmployeeChange = (employee) => {
		setIsLoading(true);
		let apiURL = "";

		if (startDate) {
			const StartDateFormated = moment(startDate).format("YYYY-MM-DD");
			const endDateFormated = moment(endDate).format("YYYY-MM-DD");
			apiURL = `${EmployeesMonthlyLeaves_API.GetEmployeesMonthlyLeaves}?EmployeeId=${employee}&PageSize=${numberOfItemsPerPage}&SortBy=${sortBy.dataField}_${sortBy.order}&StartDate=${StartDateFormated}&EndDate=${endDateFormated}`;
		} else {
			apiURL = `${EmployeesMonthlyLeaves_API.GetEmployeesMonthlyLeaves}?EmployeeId=${employee}&PageSize=${numberOfItemsPerPage}&SortBy=${sortBy.dataField}_${sortBy.order}`;
		}

		axios
			.get(apiURL, {
				headers: apiHeaderToken,
			})
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setEmployeeMonthlyLeavesData(
						res.data.employeeMonthlyLeaves
					);
				}
			});
	};
	const filterOnDateChange = (StartDate, EndDate) => {
		setIsLoading(true);
		const StartDateFormated = moment(StartDate).format("YYYY-MM-DD");
		const endDateFormated = moment(EndDate).format("YYYY-MM-DD");

		let apiURL = `${EmployeesMonthlyLeaves_API.GetEmployeesMonthlyLeaves}?StartDate=${StartDateFormated}&EndDate=${endDateFormated}&PageSize=${numberOfItemsPerPage}&EmployeeId=${selectedEmployee.value}`;

		axios
			.get(apiURL, {
				headers: apiHeaderToken,
			})
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setEmployeeMonthlyLeavesData(
						res.data.employeeMonthlyLeaves
					);
				}
			})
			.catch((err) => {
				if (err.response) {
					AlertPopups.ErrorAlert.fire({
						text: `${err.response.data.message}`,
					});
				}
			});
	};

	const receiveData = (PageSize) => {
		setIsLoading(true);
		let apiURL = "";

		if (startDate) {
			const StartDateFormated = moment(startDate).format("YYYY-MM-DD");
			const endDateFormated = moment(endDate).format("YYYY-MM-DD");
			apiURL = `${
				EmployeesMonthlyLeaves_API.GetEmployeesMonthlyLeaves
			}?PageNumber=${1}&PageSize=${PageSize}&EmployeeId=${
				selectedEmployee.value
			}&SortBy=${sortBy.dataField}_${
				sortBy.order
			}&StartDate=${StartDateFormated}&EndDate=${endDateFormated}`;
		} else
			apiURL = `${
				EmployeesMonthlyLeaves_API.GetEmployeesMonthlyLeaves
			}?PageNumber=${1}&PageSize=${PageSize}&EmployeeId=${
				selectedEmployee.value
			}&SortBy=${sortBy.dataField}_${sortBy.order}`;

		axios
			.get(apiURL, {
				headers: apiHeaderToken,
			})
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setNumberOfItemsPerPage(PageSize);
					setEmployeeMonthlyLeavesData(
						res.data.employeeMonthlyLeaves
					);
				}
			});
	};

	const exportToExcel = () => {
		setShowBtnLoading(true);
		axios({
			url: `${EmployeesMonthlyLeaves_API.ExportToExcel}?EmployeeId=${
				selectedEmployee.value
			}&StartDate=${moment(startDate).format(
				"YYYY-MM-DD"
			)}&EndDate=${moment(endDate).format("YYYY-MM-DD")}`,
			method: "GET",
			responseType: "blob",
			headers: apiHeaderToken,
		})
			.then((response) => {
				const url = window.URL.createObjectURL(
					new Blob([response.data])
				);
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "Leaves Info.xlsx");
				document.body.appendChild(link);
				link.click();
				setShowBtnLoading(false);
			})
			.catch(() => {
				setShowBtnLoading(false);
			});
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				empRole = userDetails.empRole;
				designation = userDetails.designation;
				empDepartment = userDetails.department;
				return empRole.includes("3") ||
					empRole.includes("2") ||
					designation.toString() === "4" ||
					empDepartment === "5" ? (
					<>
						<div className="container-fluid pl-3 pr-3">
							<Header
								title="Employees Monthly Leaves"
								headerBorder="false"
							/>
							<FilterationBar
								employeeList={employeeList}
								selectedEmployee={selectedEmployee}
								onEmployeeChange={(value) => {
									setSelectedEmployee(value);
									filterOnEmployeeChange(value.value);
								}}
								startDate={startDate}
								endDate={endDate}
								endDatePickerDisabled={endDatePickerDisabled}
								onStartDateChange={(startDate) => {
									setStartDate(startDate);
									//if user select start date again after selecting end date(when end date is enabled)
									if (endDate) {
										filterOnDateChange(startDate, endDate);
									} else {
										setEndDatePickerDisabled(false);
									}
								}}
								onEndDateChange={(endDate) => {
									setEndDate(endDate);
									filterOnDateChange(startDate, endDate);
								}}
							/>
							<Row>
								<Col className="d-flex justify-content-end">
									<ButtonLoader
										className={ExcelBtnClassName}
										onClick={exportToExcel}
										disabled={
											!employeeMonthlyLeavesData.length ||
											showBtnLoading
										}
										btnTitle={ExcelBtnTitle}
										showBtnLoading={showBtnLoading}
									/>
								</Col>
							</Row>
							<Col xl={10} lg={10} className="pl-0 ml-2">
								<div
									className="excluded-hours ml-0"
									style={{ fontWeight: "bold" }}
								>
									*Remaining Leave will show quota only for
									the current year.
								</div>
							</Col>

							<EmployeesMonthlyLeavesTable
								monthlyLeaves={employeeMonthlyLeavesData}
								receiveData={receiveData}
								MonthlyReimbursementTableLoader={isLoading}
								numberOfItemsPerPage={numberOfItemsPerPage}
							/>
						</div>
					</>
				) : (
					<Redirect to="/MyDashboard" />
				);
			}}
		</UserConsumer>
	);
}

export default EmployeesMonthlyLeaves;
